














































import {
  defineComponent,
  PropType,
  ref,
  getCurrentInstance
} from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccHelp from "@/components/Atoms/OccHelp/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import FieldController from "@/components/Organisms/FieldController/index.vue";

import { occFontLight } from "@/assets/styles/vars-for-script.scss";
import { useValidate } from "@/helpers/hooks/useValidate";

import { MoveOrderType } from "@/components/Organisms/InputField/types";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  components: {
    OccHeading,
    OccButton,
    OccHelp,
    TextField,
    TextArea,
    FieldController
  },
  name: "InputFieldGroup",
  props: {
    orderable: {
      type: Object as PropType<{ raise: boolean; lower: boolean }>,
      default: undefined
    },
    deletable: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    helpText: {
      type: String,
      default: ""
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  emits: ["delete", "moveOrder"],
  setup(props, { emit }) {
    const { formErrors, getFirstErrorMessage, validate } = useValidate();
    const hovered = ref<number>();
    const instance = getCurrentInstance();

    const onClickMoveOrder = (type: MoveOrderType) => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `${props.gaEventCategory}_並び替え_${
            type === "raise" ? "上げる" : "下げる"
          }`
        });
      }
      emit("moveOrder", type);
    };

    const onClickDelete = () => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `${props.gaEventCategory}_削除`
        });
      }
      emit("delete");
    };

    return {
      formErrors,
      hovered,
      getFirstErrorMessage,
      validate,
      onClickMoveOrder,
      onClickDelete,
      occFontLight
    };
  }
});
